var map = {
	"./fonts/Malvie.eot": 291,
	"./fonts/Malvie.otf": 292,
	"./fonts/Malvie.svg": 293,
	"./fonts/Malvie.ttf": 294,
	"./fonts/Malvie.woff": 295,
	"./icons/beautiful-asia.svg": 203,
	"./icons/betting.svg": 198,
	"./icons/book.svg": 204,
	"./icons/cards.svg": 205,
	"./icons/crash.svg": 199,
	"./icons/diamonds.svg": 206,
	"./icons/dragon.svg": 207,
	"./icons/egypt.svg": 208,
	"./icons/empires.svg": 209,
	"./icons/fantasy.svg": 210,
	"./icons/femme-fatale.svg": 211,
	"./icons/filter/all-games.svg": 296,
	"./icons/filter/game-providers.svg": 297,
	"./icons/filter/jackpot.svg": 212,
	"./icons/filter/lobby.svg": 213,
	"./icons/filter/new.svg": 214,
	"./icons/filter/popular.svg": 215,
	"./icons/filter/slots.svg": 298,
	"./icons/filter/table.svg": 216,
	"./icons/filthy-rich.svg": 217,
	"./icons/fortune.svg": 218,
	"./icons/fruits.svg": 200,
	"./icons/gangster.svg": 219,
	"./icons/gold.svg": 201,
	"./icons/heist.svg": 220,
	"./icons/high-seas.svg": 221,
	"./icons/hollywood.svg": 222,
	"./icons/irish.svg": 223,
	"./icons/joker.svg": 224,
	"./icons/jurassic.svg": 225,
	"./icons/keno.svg": 226,
	"./icons/latin.svg": 227,
	"./icons/music.svg": 228,
	"./icons/mystery.svg": 229,
	"./icons/safari.svg": 230,
	"./icons/sci-fi.svg": 231,
	"./icons/slots.svg": 202,
	"./icons/sports.svg": 232,
	"./icons/sweets.svg": 233,
	"./icons/treasure.svg": 234,
	"./icons/vampires.svg": 235,
	"./icons/vegas.svg": 236,
	"./icons/vikings.svg": 237,
	"./icons/wild-west.svg": 238,
	"./icons/wildlife.svg": 239,
	"./icons/wonderland.svg": 240,
	"./images/age-limit.png": 147,
	"./images/animation-mobile-logout-banner": 162,
	"./images/animation-mobile-logout-banner.json": 162,
	"./images/animation-mobile-logout-banner_old": 176,
	"./images/animation-mobile-logout-banner_old.json": 176,
	"./images/arrow-address.png": 92,
	"./images/arrow-email.png": 101,
	"./images/arrow-lottery.png": 145,
	"./images/award.png": 163,
	"./images/background-profile-mobile.png": 299,
	"./images/background-profile.png": 300,
	"./images/flag-canada.png": 112,
	"./images/interac-white-logo.png": 148,
	"./images/logo-cherry-color.png": 301,
	"./images/logo-cherry-white.png": 146,
	"./images/logo-color.png": 76,
	"./images/logo-white.png": 149,
	"./images/payment-logos.svg": 58,
	"./images/pci-dss-compliant.png": 150,
	"./images/phone-verification-background-logged-in.png": 302,
	"./images/phone-verification-background-logged-out-desktop.png": 303,
	"./images/phone-verification-background-logged-out-mobile.png": 304,
	"./images/rapid-ssl.png": 151,
	"./images/responsible-gaming.png": 241,
	"./images/rp-gamblersanonymous.png": 242,
	"./images/rp-gamblingtherapy.png": 243,
	"./images/rp-rgc.png": 244,
	"./images/secure-payments.png": 152,
	"./images/supported-payments.png": 245,
	"./images/swipe-up.png": 246,
	"./logo/logo-color-cherryspins": 99,
	"./logo/logo-color-cherryspins.json": 99,
	"./logo/logo-white-cherryspins": 177,
	"./logo/logo-white-cherryspins.json": 177,
	"./providers/betgames.png": 305,
	"./providers/betsoft.png": 306,
	"./providers/bf-games.png": 307,
	"./providers/bgaming.png": 308,
	"./providers/blueprint.png": 309,
	"./providers/endorphina.png": 310,
	"./providers/evolution.png": 311,
	"./providers/evoplay.png": 312,
	"./providers/gamevy.png": 313,
	"./providers/gamzix.png": 314,
	"./providers/hacksaw.png": 315,
	"./providers/hogaming.png": 316,
	"./providers/jetgames.png": 317,
	"./providers/kalamba.png": 318,
	"./providers/leap-virtual.png": 319,
	"./providers/leap.png": 320,
	"./providers/liw.png": 321,
	"./providers/macaw-gaming.png": 322,
	"./providers/microgaming.png": 323,
	"./providers/netent-branded.png": 324,
	"./providers/netent-standard.png": 325,
	"./providers/netent-table.png": 326,
	"./providers/platipus.png": 327,
	"./providers/playson-megaways.png": 328,
	"./providers/playson.png": 329,
	"./providers/pragmatic-play.png": 330,
	"./providers/quickspin.png": 331,
	"./providers/rabcat.png": 332,
	"./providers/realdealer.png": 333,
	"./providers/redrake.png": 334,
	"./providers/redtiger-premium.png": 335,
	"./providers/redtiger-slot.png": 336,
	"./providers/redtiger-table.png": 337,
	"./providers/skywind.png": 338,
	"./providers/spinominal.png": 339,
	"./providers/spribe.png": 340,
	"./providers/tpg.png": 341,
	"./providers/wazdan.png": 342,
	"./providers/yggdrasil.png": 343,
	"./tags/new.png": 153,
	"./tags/popular.png": 154,
	"./tags/table.png": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;